import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterOutlet,
  ActivatedRoute,
  Event,
} from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Title, Meta } from '@angular/platform-browser';
import { NavComponent } from './shared/components/nav/nav.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { GoogleTagManagerService } from './core/services/google-tag-manager.service';
import { PopupComponent } from './shared/components/popup/popup.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavComponent, FooterComponent, PopupComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  appTitle = 'myvet-diet-website';
  lastPage: string | null = null; // memorizza l’ultimo valore di page_location ogni volta che c’è un cambio route. Così, alla navigazione successiva, invia quello come referrer
  private router = inject(Router);
  private gtm = inject(GoogleTagManagerService);

  showPopup = false;
  popupTimer: any;

  @ViewChild('mainContent', { read: ElementRef }) mainContent!: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private meta: Meta
  ) {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        const seo = data['seo'] ?? {};
        if (seo.title) this.title.setTitle(seo.title);
        if (seo.description) {
          this.meta.updateTag({
            name: 'description',
            content: seo.description,
          });
        }
        // Se i “due tag” fossero altri (es. keywords/robots), aggiungili qui allo stesso modo.
      });
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd)
      )
      .subscribe(() => {
        window.scrollTo(0, 0);
      });

    this.startFirstPopupTimer();
  }

  ngAfterViewInit(): void {
    //metto tutto sotto l'altezza della navbar

    const header = document.querySelector('app-nav header');
    const mainContent = this.mainContent.nativeElement;

    if (header && mainContent) {
      const height = header.getBoundingClientRect().height;
      mainContent.style.paddingTop = `${height}px`;

      const observer = new ResizeObserver(() => {
        const newHeight = header.getBoundingClientRect().height;
        mainContent.style.paddingTop = `${newHeight}px`;
      });

      observer.observe(header);
    }
  }

  startFirstPopupTimer() {
    this.popupTimer = setTimeout(() => {
      this.showPopup = true;
    }, 10000);
  }

  onPopupClosed() {
    this.showPopup = false;

    // this.popupTimer = setTimeout(() => {
    // this.showPopup = true;
    // }, 20000);
  }
}
